/** Split textarea input into one prompt per non-empty line. */
export function parsePromptLines(raw: string): string[] {
  const seen = new Set<string>();
  const lines: string[] = [];

  for (const line of raw.split(/\r?\n/)) {
    const text = line.trim();
    if (!text) continue;
    const key = text.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    lines.push(text);
  }

  return lines;
}
